import { render, staticRenderFns } from "./risk-tip.vue?vue&type=template&id=eb542a04&scoped=true&"
import script from "./risk-tip.vue?vue&type=script&lang=js&"
export * from "./risk-tip.vue?vue&type=script&lang=js&"
import style0 from "./risk-tip.vue?vue&type=style&index=0&id=eb542a04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb542a04",
  null
  
)

component.options.__file = "risk-tip.vue"
export default component.exports